import React, { useEffect, useReducer, useRef, useState } from 'react'
import styles from './../SuperSearch.module.css'
import { enumUtil } from '../../../../utils/Enum'
import NotificationHandler from '../../../../utils/NotificationHandler'
import { ServerRequestProtected } from '../../../../utils/ServerDataRequest'
import useDebounce from '../../../../customhooks/useDebounce'
import isNull from '../../../../utils/NullChecking'
import Tab from "react-bootstrap/Tab";
import Nav from "react-bootstrap/Nav";
import GridColumnHeader from '../../../Setup/Shared/GridColumnHeader'
// =============================== CUSTOM HELPER FUNCTIONS ==========================
const getupdateArray = (cols, rows) => {
  const updatedarr = rows.map((row) => {
    let obj = {}
    cols.forEach((ele) => {
      // const ddd = ele.replace(/\s/g, '').toLowerCase()
      obj[ele.bindingValue] = row[ele.bindingValue]
    })

    return obj
  })
  return updatedarr
}

/** ================                             ===============
 * =================  PROPS AND THERE USES ===============
 *  ================                             ===============
//  * ApiLink: complete api link from whre you want to search your result ... *required
//  * method: name of method you are using to hit API. Only two methods are allowed (post and get)...*required
//  * postBody:if you are  using post method in method prop then you need to pass an object ....* only required if method="post"
 * tableHeight: if you want to set custom height of table (type:number, eg 45,69) ...*required
 * tableWidth : if you want to set custom width of table(type:string, eg:"34px","76px")
 * getSelectedData: pass function which  give complete data of single row you clicked on its first parameter...*required
 * onChange: pass function which which will chnge the input field...*required
 * searchValue: value used in inputfield...*required
 * id: any unique string...*required
 * tableData:it will be an array of object with 3 keys
 *            columName:string to show as a column name...*required
 *            bindingValue: to show the value in each column.... must match with the api response...*required
 *            columnWidth: string to set custom width og each column in % eg: 12%,34%
 * customData: it will be an array of object with 4 key
 *              id:any unique string
 *              label:any string
 *              value:any string
 *              description:any string
 * Note: when there is data in customData then no api will run
 */

const SuperICDandCPTSearch = (props) => {
  let { searchValue } = props;
  searchValue = searchValue ?? "";
  const [tableData, setTableData] = useState([])
  const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })
  const [gridHeaderSearchResult, handleGridHeaderSearchResult] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })
  const [gridHeaderDxData, handleGridHeaderDxData] = useReducer((prev, next) => {
    return { ...prev, ...next }
  }, { defaultData: '', activeSortIcon: '' })
  const [SearchResults, setSearchResults] = useState([])
  const [PatientDxData, setPatientDxData] = useState([])
  const [noResponse, setnoResponse] = useState(false)
  const [selectedRowNumber, setSelectedRowNumber] = useState(0)
  const [showTable, setShowTable] = useState(false)
  const [searchStatus, setSearchStatus] = useState(false)
  const [selectedValue, setSelectedValue] = useState(props?.searchValue)
  const tableBodyRef = useRef(null);
  const inputRef = useRef(null);
  const debouncedSearchTerm = useDebounce(searchValue, 2);
  const [activeTab, setActiveTab] = useState(props.DefaultActiveTab ? props.DefaultActiveTab : 'RecentAdded')
  const listRef = useRef(null);

  const [isOptionSelected, setIsOptionSelected] = useState()
  useEffect(() => {
    if (props.isItemSelected) {
      setIsOptionSelected(true)
    } else {
      setIsOptionSelected(false)
    }
  }, [props.isItemSelected])
  const [divStyle, setDivStyle] = useState({});
  const dropdownRef = useRef(null);
  const addNewButtonRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const dropdownTimeoutRef = useRef(null); // For debounce/cleanup
  const activeInputRef = useRef(null);

  const handleParentClick = (event, shouldHideFirst = true) => {
    // Clear any previous timeout
    if (dropdownTimeoutRef.current) {
      clearTimeout(dropdownTimeoutRef.current);
    }

    const rect = event.currentTarget.getBoundingClientRect();
    const dropdownWidth = 342; // Adjust to your dropdown's fixed width
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // ✅ Step 1: Hide it first only if needed (e.g. input click, not tab switch)
    if (shouldHideFirst) {
      setDivStyle({
        top: -9999,
        left: -9999,
        position: "fixed",
        opacity: 0,
        pointerEvents: "none",
        visibility: "hidden",
      });
    }

    // ✅ Step 2: Wait for DOM update, then measure + show dropdown
    dropdownTimeoutRef.current = setTimeout(() => {
      const dropdownElement = dropdownRef.current;
      const actualDropdownHeight =
        dropdownElement?.offsetHeight && dropdownElement.offsetHeight > 0
          ? dropdownElement.offsetHeight
          : 207.4; // fallback height if not rendered yet

      let top = rect.bottom;
      if (rect.bottom + actualDropdownHeight > viewportHeight) {
        // If dropdown would overflow bottom, show above
        top = rect.top - actualDropdownHeight;
      }

      let left = rect.left;
      if (rect.left + dropdownWidth > viewportWidth) {
        // If overflow on right, shift left
        left = viewportWidth - dropdownWidth - 10;
      }
      if (left < 0) {
        // Avoid clipping on left
        left = 10;
      }

      // ✅ Step 3: Show dropdown at final calculated position
      setDivStyle({
        top,
        left,
        position: "fixed",
        opacity: 1,
        pointerEvents: "auto",
        visibility: "visible",
      });
    }, 0);
  };



  // ====================== RESETING THE COMPONENT TO ITS ORIGINAL STATE Blur================
  const onBlurDefault = (e) => {
    // if (props.handleOnblur) {
    //   props.handleOnblur()
    // }
    // deb
    if (isOptionSelected) {
      // if (selectedValue.length === 0) {
      //   props.getSelectedData(null, props.name, props.type)
      // }
    } else {
      props.getSelectedData(null, props.name, props.type)
    }
    // setTableData([])
    setSelectedRowNumber(0)
    setShowTable(false)
    setSearchStatus(false)
    setSelectedValue('')
  }

  // ====================== ON CLICKING SINGLE ROW OF TABLE ================
  const handleSingleRow = (singlerow, index) => {
    setIsOptionSelected(true)
    setSelectedRowNumber(index)
    props.getSelectedData(singlerow, props.name, props.type)
    setSelectedRowNumber(0)
    setShowTable(false)
    setSearchStatus(false)
    setSelectedValue(singlerow?.value)
  }

  // ========================= ON KEY DOWN PRESSED INPUT FIELD======================

  const updateKeyUp = (param) => {
    setSelectedRowNumber(prev => {
      const currentIndex = parseInt(prev?.split('-')[1]) || 0;
      if (currentIndex > 0) {
        const newIndex = currentIndex - 1;
        const newId = `${param}-${newIndex}`;
        handleScrollIntoView(newId);
        return newId;
      } else {
        const newId = `${param}-0`;
        handleScrollIntoView(newId);
        return newId;
      }
    });
  }
  const updateKeyDown = (param) => {
    setSelectedRowNumber(prev => {
      const currentIndex = parseInt(prev?.split('-')[1]) || 0;
      if (currentIndex >= 0) {
        const newIndex = currentIndex + 1;
        const newId = `${param}-${newIndex}`;
        handleScrollIntoView(newId);
        return newId;
      }
    });
  }

  const updateEnterKey = async (type) => {
    if (type.length > 0) {
      // Extract numeric index from selectedRowNumber
      const rowIndex = typeof selectedRowNumber === 'string'
        ? parseInt(selectedRowNumber.split('-')[1])
        : selectedRowNumber;

      // Ensure index is within bounds
      const selectedItem = type[Math.min(rowIndex, type.length - 1)];

      if (selectedItem) {
        setIsOptionSelected(true);
        await props.getSelectedData(selectedItem, props.name, props.type);
        setShowTable(false);
        setSelectedRowNumber(0);
        setSearchStatus(false);
        setSelectedValue(selectedItem?.value);
      }
    }
  }
  const updateTabKey = async (type) => {
    if (type.length === 1) {
      setIsOptionSelected(true);
      await props.getSelectedData(type[0], props.name, props.type);
      setShowTable(false);
      setSelectedRowNumber(0);
      setSearchStatus(false);
      setSelectedValue(type[0]?.value);
    } else {
      onBlurDefault();
    }
  }

  const onKeyDownPressed = async (e) => {
    if (e.keyCode === 13) {
      if (activeTab === 'RecentAdded') {
        updateEnterKey(tableData)
      } else if (activeTab === 'SearchResults') {
        updateEnterKey(SearchResults)
      } else if (activeTab === 'MyDXList') {
        updateEnterKey(PatientDxData)
      }
      // User pressed the ENTER key
      // if (tableData.length > 0) {
      //   setIsOptionSelected(true)
      //   await props.getSelectedData(tableData[selectedRowNumber], props.name, props.type)
      //   setShowTable(false)
      //   setSelectedRowNumber(0)
      //   setSearchStatus(false)
      //   setSelectedValue(tableData[selectedRowNumber]?.value)
      // }
    } else if (e.keyCode === 38) {
      // if user presses the UP
      if (activeTab === 'RecentAdded') {
        if (selectedRowNumber > 0) {
          setSelectedRowNumber((prevSelectedRow) => prevSelectedRow - 1)
          handleScrollIntoView(selectedRowNumber - 1)
        }
      } else if (activeTab === 'SearchResults') {
        updateKeyUp('row')
      } else if (activeTab === 'MyDXList') {
        updateKeyUp('Dx')
      }
      // }
    } else if (e.keyCode === 40) {
      // IF USER PRESSES DOWN KEY
      let selectetRow = activeTab === 'RecentAdded' ? selectedRowNumber : selectedRowNumber.split('-')[1]
      // if (selectetRow < tableData.length - 1) {
      // setSelectedRowNumber((prevSelectedRow) => prevSelectedRow + 1)
      // handleScrollIntoView(selectedRowNumber + 1)
      if (activeTab === 'RecentAdded' && selectetRow < tableData.length - 1) {
        if (selectedRowNumber >= 0) {
          setSelectedRowNumber((prevSelectedRow) => prevSelectedRow + 1)
          handleScrollIntoView(selectedRowNumber + 1)
        }
      } else if (activeTab === 'SearchResults' && selectetRow < SearchResults.length - 1) {
        updateKeyDown('row')
      } else if (activeTab === 'MyDXList') {
        updateKeyDown('Dx')
      }
      

      // }
    } else if (e.keyCode === 27) {
      // IF USER PRESSES ESC KEY THEN RESET THE COMPONENT TO ITS ORIGINAL STATE
      props.getSelectedData(null)
      setTableData([])
      setSearchResults([])
      setPatientDxData([])
      setShowTable(false)
      setSelectedRowNumber(0)
    } else if (e.keyCode === 9) {
      // IF USER PRESSES THE TAB BUTTON
      if (activeTab === 'RecentAdded') {
        updateTabKey(tableData)
      } else if (activeTab === 'SearchResults') {
        updateTabKey(SearchResults)
      } else if (activeTab === 'MyDXList') {
        updateTabKey(PatientDxData)
      }
      // if (tableData.length === 1) {
      //   setIsOptionSelected(true)
      //   await props.getSelectedData(tableData[0], props.name, props.type)
      //   setShowTable(false)
      //   setSelectedRowNumber(0)
      //   setSearchStatus(false)
      //   setSelectedValue(tableData[0]?.value)
      // } else {
      //   onBlurDefault();
      // }
    }
  }

  // =========================== ON CHANGE HANDLER OF THE INPUT FIELD =============================
  const onHandleChange = async (e) => {
    props.onChange(e)
    setIsOptionSelected(false)
    let eventValue = e.target.value
    if (eventValue === '') {
      setnoResponse(false)
      setActiveTab('RecentAdded')
      return
    }
    // setSelectedValue(eventValue)
    if (eventValue === '' && !props?.type === 'server') {
      setSearchStatus(false)
      setSelectedRowNumber(0)
    } else if (eventValue === '' && props?.type === 'server' && props?.tableData?.length > 0) {
      setSearchStatus(true)
      setSelectedRowNumber(0)
    } else {
      setSearchStatus(true)
    }
  }


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        tableBodyRef.current && tableBodyRef.current.contains(event.target) // Click inside dropdown
      ) {
        return; // Do nothing, keep the dropdown open
      }
      if (
        dropdownRef.current && dropdownRef.current.contains(event.target) // Click inside tabs
      ) {
        return; // Do nothing, keep the dropdown open
      }
      if (
        addNewButtonRef.current && addNewButtonRef.current.contains(event.target) // Click inside tabs
      ) {
        return; // Do nothing, keep the dropdown open
      }
      if (inputRef.current && inputRef.current.contains(event.target)) {
        // setShowTable(prev => !prev);
        return; // Do nothing, keep the dropdown open
      }
      // Click outside, close the dropdown
      setnoResponse(false)
      setShowTable(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const searchByKeys = (data) => {
    const searchTerm = debouncedSearchTerm?.toLowerCase();
    if (props?.searchBy) {
      return props.searchBy.some((key) =>
        data[key]?.toLowerCase().includes(searchTerm)
      );
    }
    return data.display?.toLowerCase().includes(searchTerm);
  };
  useEffect(() => {
    const abortController = new AbortController();

    const searchAndSetData = (dataSource) => {
      const results = dataSource.filter((cdata) => searchByKeys(cdata));
      if (activeTab === 'SearchResults') {
        setSearchResults(results)
        handleGridHeaderSearchResult({ defaultData: results })
      } else if (activeTab === 'MyDXList') {
        setPatientDxData(results)
        handleGridHeaderDxData({ defaultData: results })
      } else {
        setTableData(results);
        handleGridHeader({ defaultData: results })
      }
      if (results.length > 0) {
        setnoResponse(false);
        setShowTable(true);
        return true;
      }
      return false;
    };

    const fetchFromAPI = async () => {
      try {
        if (!props.postBody) {
          throw new Error("Post Body prop is not defined");
        }
        setIsLoading(true);
        const api_Response = await ServerRequestProtected(
          props.ApiLink,
          props.method,
          props.postBody,
          abortController.signal
        );
        setIsLoading(false);
        if (api_Response.length > 0) {
          setSearchResults(api_Response);
          handleGridHeaderSearchResult({ defaultData: api_Response })
          setShowTable(true);
          setnoResponse(false);
        } else {
          setnoResponse(true);
          // setShowTable(false);
        }
      } catch (error) {
        setIsLoading(false);
        setnoResponse(true);
        // setShowTable(false);
        setSearchResults([]);
        NotificationHandler(error, enumUtil.enumtoaster.warning);
      }
    };

    
    const handleSearch = async () => {
      const { PatDxData, customData } = props;
      if (activeTab === 'MyDXList') {
        setPatientDxData(PatDxData);
        handleGridHeaderDxData({ defaultData: PatDxData })
      } else {
        setTableData(customData);
        handleGridHeader({ defaultData: customData })
      }

      if (!searchStatus || isNull(debouncedSearchTerm) || debouncedSearchTerm.length < 2) return;

      let found = false;

      if (activeTab === 'MyDXList' && PatDxData.length > 0) {
        found = searchAndSetData(PatDxData);
      }

      if (!found && activeTab === 'MyDXList') {
        setSelectedRowNumber(`row-0`)
        setActiveTab('SearchResults');
        found = searchAndSetData(customData);
      } else if (!found && customData?.length > 0) {
        found = searchAndSetData(customData);
      }

      if (!found) {
        if (props.method === "post") {
          await fetchFromAPI();
        }
        setSelectedRowNumber(`row-0`)
        setActiveTab('SearchResults');

      }
    };

    handleSearch();

    return () => {
      abortController.abort();
    };
  }, [debouncedSearchTerm]);
  useEffect(() => {
    const tableBodyElement = tableBodyRef?.current;
    const isListOpen = showTable && tableData?.length > 0;

    const handleScroll = (e) => {
      // Check to Prevent if target is List 
      if (tableBodyElement && !tableBodyElement.contains(e.target)) {
        e.preventDefault();
      }
    };
    if (isListOpen) {
      // Disable scrolling on the body if target is outside list
      document.body.style.overflow = "hidden";
      document.addEventListener("wheel", handleScroll, { passive: false });
    } else {
      // Re-enable scrolling on the body
      document.body.style.overflow = "auto";
      document.removeEventListener("wheel", handleScroll);
    }
    // Cleanup on component unmount
    return () => {
      document.body.style.overflow = "auto";
      document.removeEventListener("wheel", handleScroll);
    };
  }, [showTable, tableData?.length, props?.customData, tableBodyRef]);
  const handleBlur = (e) => {
    let { value, name } = e.target
    setIsLoading(false)
    // setActiveTab(props.DefaultActiveTab ? props.DefaultActiveTab : 'RecentAdded')
    if (!dropdownRef.current?.contains(document.activeElement)) {
      setActiveTab(props.DefaultActiveTab ? props.DefaultActiveTab : 'RecentAdded')
    }
    setTableData(props.customData)
    // handleGridHeader({ defaultData: props.customData })
    setSearchResults([])
    if (props.handleOnblur) {
      props.handleOnblur(value, name)
    }

    if (props?.type !== "server") return;
    // if (isNull(searchValue) && isNull(selectedValue)) return;
    // if (searchValue === selectedValue) return;
    // if (tableData.length === 1) {
    //   handleSingleRow(tableData[0], 0);
    // } else
    if (!tableBodyRef.current) {
      onBlurDefault(e);
    }
  }
  const handleFocus = (e) => {
    if (activeTab === 'MyDXList') {
      setPatientDxData(props.PatDxData)
      //  handleGridHeaderDxData({ defaultData: props.PatDxData })
    }
    handleParentClick(e);
    if (props.customData?.length > 0) {
      if (tableData.length > 0) {
        const initialIndex = props.customData.findIndex(
          (item) => (item.value === props.searchValue || item.display === props.searchValue)
        );
        if (initialIndex > 0) {
          setSelectedRowNumber(initialIndex);
          handleScrollIntoView(initialIndex);
        } else {
          setSelectedRowNumber(0);
        }
      }
    } else {
      setActiveTab('SearchResults')
    }

    if (props.handleonFocus) {
      props.handleonFocus()
    }
  }

  const handleScrollIntoView = (index) => {
    setTimeout(() => {
      const elem = document.getElementById(index);
      if (elem) {
        elem.scrollIntoView({
          // behavior: 'smooth',
          block: 'nearest',
          // inline: 'start',
        });
      }
    }, 0);
  }

  const handleTabClickScroll = (param) => {
    let initialIndex = props.customData.findIndex(
      (item) => (item.value === props.searchValue || item.display === props.searchValue)
    );
    if (initialIndex === -1) {
      initialIndex = 0
    }
    if (isNull(param)) {
      setSelectedRowNumber(initialIndex);
    } else {
      setSelectedRowNumber(`${param}-${initialIndex}`);
    }
    // handleScrollIntoView(initialIndex);
    setTimeout(() => {
      let elem
      if (isNull(param)) {
        elem = document.getElementById(initialIndex);
      } else {
        elem = document.getElementById(`${param}-${initialIndex}`);
      }
      if (elem) {
        elem.scrollIntoView({
          block: 'nearest',
        });
      }
    }, 200);
  }

  const handleTabClick = async (event, key) => {
    setActiveTab(key);
    if (key === 'RecentAdded') {
      // Only set RecentAdded data when switching to this tab
      if (props.customData?.length > 0) {
        handleTabClickScroll()
        setTableData(props.customData);
        handleGridHeader({ defaultData: props.customData })

      }
    } else if (key === 'SearchResults') {
      if (tableData.length > 0) {
        handleTabClickScroll('row')
      }
    } else if (key === 'MyDXList') {
      if (props.PatDxData.length > 0) {
        // setTableData(props.PatDxData)
        setPatientDxData(props.PatDxData)
        handleGridHeaderDxData({ defaultData: props.PatDxData })
        let initialIndex = props.PatDxData.findIndex(
          (item) => (item.value === props.searchValue || item.display === props.searchValue)
        );
        if (initialIndex === -1) {
          initialIndex = 0
        }
        setSelectedRowNumber(`Dx-${initialIndex}`);
        // handleScrollIntoView(initialIndex);
        setTimeout(() => {
          let elem
          elem = document.getElementById(`Dx-${initialIndex}`);
          if (elem) {
            elem.scrollIntoView({
              block: 'nearest',
            });
          }
        }, 200);
      }
    }

    // ✅ Always reposition dropdown if an input was clicked previously
    setTimeout(() => {
      if (activeInputRef?.current) {
        handleParentClick({ currentTarget: activeInputRef.current }, false); // false = don't hide
      }
    }, 250); // run after row scroll finishes
  };

  const handleAddNew = () => {
    props.handleAddNewCode(searchValue, props.name)
    onBlurDefault()
  }
  const handleOnClick = (e) => {
    if (showTable) {
      setShowTable(false);
    } else {
      setShowTable(true)
      handleFocus(e)
    }
  }
  return (
    <>
      <div
        id={`superSearchParentDiv_${props.id}`}
        className="position-relative"
        style={{ width: props.inputFieldWidth ? props.inputFieldWidth : '' }}
        ref={listRef}
      >
        <div className={`input-group icd-input-loader ${styles[props.sup_inp]}`}
        // onClick={handleParentClick}
        >
          <input
            ref={inputRef}
            onKeyDown={onKeyDownPressed}
            onChange={onHandleChange}
            name={props.name}
            value={searchValue}
            id={`superSearchInputField_${props.id}`}
            type="text"
            autoComplete="off"
            className={props.inputError ? `col ${styles.sup_yellowsearch_error}` : `col ${styles.sup_yellowsearch}`}
            placeholder={props.placeholder === false ? null : props.placeholder ? props.placeholder : "Search..."}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onClick={handleOnClick}
            readOnly={props.isReadOnly ? true : false}
            onMouseDown={(e) => {
              activeInputRef.current = e.currentTarget;       // 👈 Track the clicked input
              handleParentClick(e);                           // 👈 Show dropdown on first click
            }}

          />
          {isLoading ?
            <div className='last_loader ar-small-loader'>
              <div class="circle circle1"></div>
              <div class="circle circle2"></div>
            </div> :
            null}
        </div>
        {(
          (showTable && searchStatus && selectedValue === searchValue) ||
          (showTable && props?.type === 'server')
        ) ? (
          <>
            {props.isReadOnly === true ? null :
              <div className='ar_superSearch-tabs-desc-list' ref={dropdownRef} style={{ ...divStyle }}>
                <Tab.Container activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
                  <Nav variant="tabs" className="d-flex border-0 gx-0 px-2 py-1 gap-10">
                    <Nav.Item>
                      <Nav.Link
                        eventKey="SearchResults"
                        className="text fs-10"
                        onMouseDown={(e) => handleTabClick(e, 'SearchResults')} // Prevents the input from losing focus
                      >Search Results
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="RecentAdded" className="text fs-10"
                        onMouseDown={(e) => handleTabClick(e, 'RecentAdded')}
                      >Recent Added</Nav.Link>
                    </Nav.Item>
                    {props.showPatDx ?
                      <Nav.Item>
                        <Nav.Link eventKey="MyDXList" className="text fs-10"
                          onMouseDown={(e) => handleTabClick(e, 'MyDXList')}
                        >Patient DX </Nav.Link>
                      </Nav.Item> : null}
                  </Nav>
                  <Tab.Content ref={tableBodyRef}>
                    <Tab.Pane eventKey="SearchResults">
                      {SearchResults.length > 0 ?
                        <div className="ar_list-header">
                          <div className="ar_list-header-content d-flex w-100 align-items-center px-10 gap-2">
                            <div className="d-flex align-items-center gap-1 option" onMouseDown={(e) => e.preventDefault()}>
                              <p className='heading ar-dark-color'>
                                <GridColumnHeader
                                  gridHeader={gridHeaderSearchResult}
                                  handleGridHeader={handleGridHeaderSearchResult}
                                  iconName={'icon-card'}
                                  headerName={'Code'}
                                  sortIcon={true}
                                  type={'string'}
                                  colKey={'display'}
                                  data={SearchResults}
                                  setData={setSearchResults}
                                  onMouseDown={(e) => e.preventDefault()}
                                />
                              </p>
                              {/* <p className='heading ar-dark-color'>Code</p> */}
                              {/* {true && <span class="icon-sorting fs-12 "></span>} */}
                              {/* {false && <span class="icon-sorting-up fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                              {/* {false && <span class="icon-sorting-down fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                            </div>
                            <div className="d-flex align-items-center gap-1 option" onMouseDown={(e) => e.preventDefault()}>
                              <p className='heading ar-dark-color'>
                                <GridColumnHeader
                                  gridHeader={gridHeaderSearchResult}
                                  handleGridHeader={handleGridHeaderSearchResult}
                                  iconName={'icon-card'}
                                  headerName={'Description'}
                                  sortIcon={true}
                                  type={'string'}
                                  colKey={'Description'}
                                  data={SearchResults}
                                  setData={setSearchResults}
                                  onMouseDown={(e) => e.preventDefault()}
                                />
                              </p>
                              {/* <p className='heading ar-dark-color'>Description</p> */}
                              {/* {true && <span class="icon-sorting fs-12 "></span>} */}
                              {/* {false && <span class="icon-sorting-up fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                              {/* {false && <span class="icon-sorting-down fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                            </div>
                          </div>
                        </div>
                        :
                        null}
                      <div className="all_options-list hover-scrollbar">
                        {SearchResults.length > 0 ?
                          SearchResults.map((tdata, index) => {
                            console.log(tdata, 'SearchResults');

                            let row_selected = false
                            if (`row-${index}` === selectedRowNumber) {
                              row_selected = true
                            }
                            return (
                              <div
                                className="list_item"
                                id={`row-${index}`}
                                key={index}
                                onMouseDown={() =>
                                  handleSingleRow(SearchResults[index], index)
                                }
                              >
                                <div className={`p-1 px-2 d-flex option gap-2 ${row_selected ? 'active' : ''}`}>
                                  {props?.tableData?.length > 0 &&
                                    props.tableData.map((it, index) => {
                                      return <p title={tdata?.[it?.bindingValue]} className={it?.bindingValue === "display" ? 'heading' : 'text multiline-ellipsis'}>{tdata?.[it?.bindingValue]}</p>
                                    })}
                                </div>
                              </div>
                            )
                          }) :
                          <div className="">
                            <div className="ar_no-data-found" >
                              <div className="d-flex align-items-center justify-content-center no_text">
                                <p className="text ar-light-color">Not found in the system!</p>
                              </div>
                              <div className="d-flex justify-content-between align-items-center px-2"  >
                                {!isNull(searchValue) ?
                                  <div className="d-flex align-items-center gap-1 cursor-pointer" ref={addNewButtonRef}>
                                    <i className="icon-dash-plus fw-900"></i>
                                    {props.handleAddNewCode ?
                                      <p className="text fs-11 validate-color text-decoration-underline lh-1"
                                        onMouseDown={(e) => {
                                          e.stopPropagation();
                                          handleAddNew();
                                        }}
                                      >
                                        `Add “{searchValue}” As New {props.id}`
                                      </p>
                                      : null}
                                  </div>
                                  : null}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="RecentAdded" >
                      {tableData?.length > 0 ?
                        <div className="ar_list-header">
                          <div className="ar_list-header-content d-flex w-100 align-items-center px-10 gap-2">
                            <div className="d-flex align-items-center gap-1 option">
                              <p className='heading ar-dark-color'>
                                <GridColumnHeader
                                  gridHeader={gridHeader}
                                  handleGridHeader={handleGridHeader}
                                  iconName={'icon-card'}
                                  headerName={'Code'}
                                  sortIcon={true}
                                  type={'string'}
                                  colKey={'DiagnosisCode'}
                                  data={tableData}
                                  setData={setTableData}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </p>
                              {/* <p className='heading ar-dark-color'>Code</p> */}
                              {/* {true && <span class="icon-sorting fs-12 "></span>} */}
                              {/* {false && <span class="icon-sorting-up fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                              {/* {false && <span class="icon-sorting-down fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                            </div>
                            <div className="d-flex align-items-center gap-1 option">
                              <p className='heading ar-dark-color'>
                                <GridColumnHeader
                                  gridHeader={gridHeader}
                                  handleGridHeader={handleGridHeader}
                                  iconName={'icon-card'}
                                  headerName={'Description'}
                                  sortIcon={true}
                                  type={'string'}
                                  colKey={'Description'}
                                  data={tableData}
                                  setData={setTableData}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </p>
                              {/* <p className='heading ar-dark-color'>Description</p> */}
                              {/* {true && <span class="icon-sorting fs-12 "></span>} */}
                              {/* {false && <span class="icon-sorting-up fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                              {/* {false && <span class="icon-sorting-down fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                            </div>
                          </div>
                        </div>
                        :
                        null}
                      <div className="all_options-list hover-scrollbar" >
                        {tableData?.length > 0 ?
                          tableData.map((tdata, index) => {
                            let row_selected = false
                            if (index === selectedRowNumber) {
                              row_selected = true
                            }
                            return (
                              <div
                                className="list_item"
                                id={index}
                                key={index}
                                onMouseDown={() =>
                                  handleSingleRow(tableData[index], index)
                                }
                              >
                                <div className={`p-1 px-2 d-flex gap-2 option  ${row_selected ? 'active' : ''}`}>
                                  {props?.tableData?.length > 0 &&
                                    props.tableData.map((it, index) => {
                                      return <p title={tdata?.[it?.bindingValue]} className={it?.bindingValue === "display" ? 'heading' : 'text multiline-ellipsis'}>{tdata?.[it?.bindingValue]}</p>
                                    })}
                                </div>
                              </div>
                            )
                          }) : null
                        }
                      </div>
                    </Tab.Pane>
                    <Tab.Pane eventKey="MyDXList">
                      {PatientDxData.length > 0 ?
                        <div className="ar_list-header">
                          <div className="ar_list-header-content d-flex w-100 align-items-center px-10 gap-2">
                            <div className="d-flex align-items-center gap-1 option">
                              <p className='heading ar-dark-color'>
                                <GridColumnHeader
                                  gridHeader={gridHeaderDxData}
                                  handleGridHeader={handleGridHeaderDxData}
                                  iconName={'icon-card'}
                                  headerName={'Code'}
                                  sortIcon={true}
                                  type={'string'}
                                  colKey={'DiagnosisCode'}
                                  data={PatientDxData}
                                  setData={setPatientDxData}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </p>
                              {/* <p className='heading ar-dark-color'>Code</p> */}
                              {/* {true && <span class="icon-sorting fs-12 "></span>} */}
                              {/* {false && <span class="icon-sorting-up fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                              {/* {false && <span class="icon-sorting-down fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                            </div>
                            <div className="d-flex align-items-center gap-1 option">
                              <p className='heading ar-dark-color'>
                                <GridColumnHeader
                                  gridHeader={gridHeaderDxData}
                                  handleGridHeader={handleGridHeaderDxData}
                                  iconName={'icon-card'}
                                  headerName={'Description'}
                                  sortIcon={true}
                                  type={'string'}
                                  colKey={'Description'}
                                  data={PatientDxData}
                                  setData={setPatientDxData}
                                  onClick={(e) => e.stopPropagation()}
                                />
                              </p>
                              {/* <p className='heading ar-dark-color'>Description</p> */}
                              {/* {true && <span class="icon-sorting fs-12 "></span>} */}
                              {/* {false && <span class="icon-sorting-up fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                              {/* {false && <span class="icon-sorting-down fs-12"><span class="path1"></span><span class="path2"></span></span>} */}
                            </div>
                          </div>
                        </div>
                        :
                        null}
                      <div className="all_options-list hover-scrollbar" >
                        {PatientDxData.length > 0 ?
                          PatientDxData.map((tdata, index) => {
                            let row_selected = false
                            if (`Dx-${index}` === selectedRowNumber) {
                              row_selected = true
                            }
                            return (
                              <div
                                className="list_item"
                                id={`Dx-${index}`}
                                key={index}
                                onMouseDown={() =>
                                  handleSingleRow(PatientDxData[index], index)
                                }
                              >
                                <div className={`p-1 px-2 d-flex gap-2 option  ${row_selected ? 'active' : ''}`}>
                                  {props?.tableData?.length > 0 &&
                                    props.tableData.map((it, index) => {
                                      return <p title={tdata?.[it?.bindingValue]} className={it?.bindingValue === "display" ? 'heading' : 'text multiline-ellipsis'}>{tdata?.[it?.bindingValue]}</p>
                                    })}
                                </div>
                              </div>
                            )
                          }) : <div className="">
                            <div className="ar_no-data-found" >
                              <div className="d-flex align-items-center justify-content-center no_text">
                                <p className="text ar-light-color">Not found in the system!</p>
                              </div>
                              <div className="d-flex justify-content-between align-items-center px-2"  >
                                {!isNull(searchValue) ?
                                  <div className="d-flex align-items-center gap-1 cursor-pointer" ref={addNewButtonRef}>
                                    <i className="icon-dash-plus fw-900"></i>
                                    {props.handleAddNewCode ?
                                      <p className="text fs-11 validate-color text-decoration-underline lh-1"
                                        onMouseDown={(e) => {
                                          e.stopPropagation();
                                          handleAddNew();
                                        }}
                                      >
                                        ` Add “{searchValue}” As New {props.id}`
                                      </p>
                                      : null}
                                  </div>
                                  : null}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            }
          </>
        ) : null}
        {/* {noResponse ?
          <div className="" ref={tableBodyRef}>
            <div className="ar_superSearch-tabs-desc-list" ref={dropdownRef} style={{ ...divStyle }}>
              <div className="ar_no-data-found">
                <div className="d-flex align-items-center justify-content-center no_text">
                  <p className="text ar-light-color">Not found in the system!</p>
                </div>
                <div className="d-flex justify-content-between align-items-center px-2"  >
               
                  <div className="d-flex align-items-center gap-1 cursor-pointer">
                    <i className="icon-dash-plus fw-900"></i>
                    {props.handleAddNewCode ? <p className="text fs-11 validate-color text-decoration-underline lh-1" onClick={() => handleAddNew()}>Add “{searchValue}” As New {props.id}</p> : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          : null} */}

        {/* {NewICDPopup}
        {NewCPTPopup} */}
      </div>
    </>
  )
}
export default SuperICDandCPTSearch
